import { render, staticRenderFns } from "./orderSellList.vue?vue&type=template&id=25547089"
import script from "./orderSellList.vue?vue&type=script&lang=js"
export * from "./orderSellList.vue?vue&type=script&lang=js"
import style0 from "./orderSellList.vue?vue&type=style&index=0&id=25547089&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports